module.exports = __webpack_public_path__ + "static/banner-img-9bd694add59c7b2f33388aca67c6e0bc.jpg";